<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- Edit -->
            <a href="javascript:;" class="btn btn-sm btn-light btn-with-addon mr-2"
               @click="showEditModal(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
              Edit
            </a>

            <!-- Delete -->
            <a href="javascript:;" class="btn btn-sm btn-danger btn-with-addon"
               @click="onDelete(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
              Delete
            </a>

          </div>
        </template>
      </a-table>
    </div>
    <edit-room @onEdited="handleAfteredit"/>
  </div>
</template>

<script>
import EditRoom from '@/components/hostel/manage/hostel-room/edit'
const columns = [
  { title: 'Room No.', width: 130, className: 'text-wrap', dataIndex: 'room_number', scopedSlots: { customRender: 'room_number' } },
  { title: 'Capacity', width: 100, className: 'text-center', dataIndex: 'capacity', scopedSlots: { customRender: 'capacity' } },
  { title: 'Occupied', width: 100, className: 'text-center', dataIndex: 'occupied', scopedSlots: { customRender: 'occupied' } },
  { title: 'Vacancy', width: 100, className: 'text-center', dataIndex: 'room_vacancy', scopedSlots: { customRender: 'room_vacancy' } },
  { title: 'Hostel', width: 130, className: 'text-center text-wrap', dataIndex: 'hostel.name', scopedSlots: { customRender: 'hostel.name' } },
  { title: 'Block', width: 130, className: 'text-center text-wrap', dataIndex: 'block.name', scopedSlots: { customRender: 'block.name' } },
  { title: 'Facility', width: 120, className: 'text-center text-wrap', dataIndex: 'facility.name', scopedSlots: { customRender: 'facility.name' } },
  { title: 'Description', width: 160, className: 'text-center text-wrap', dataIndex: 'description', scopedSlots: { customRender: 'description' } },
  { title: 'Actions', width: 200, className: 'text-right', scopedSlots: { customRender: 'action' } },
]

export default {
  name: 'roomTable',
  components: {
    EditRoom,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      columns,
    }
  },
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    showEditModal(record) {
      this.$eventBus.$emit('openEditForm', record)
    },
    handleAfteredit() {
      this.$emit('updateTable')
    },
    onDelete: function(record) {
      this.$confirm({
        title: 'Are you sure delete this room?',
        content: `You are about to delete this room.`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/hostel/room/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: record.room_number + ' has been deleted.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
